<template>
  <div class="table-responsive">

    <table id="general-table" class="table table-striped table-bordered table-vcenter">
      <thead>
        <tr>
          <slot name="label"></slot>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td
            :colspan="fields.length"
            class="text-center"
            v-if="(data.Length || data) == 0 && !loading"
          >
            No se encontraron datos
          </td>
        </tr>

        <template v-if="!loading">
          <tr v-for="(row, index) in displayedPosts" :key="index">
            <template v-for="(field, _index) in fields">
              <td
                :key="_index"
                :class="$children[_index].$options.propsData.customClass"
                :style="
                  componentName != 'InformacionContacto'
                    ? null
                    : typeof row.informacion_adicional == 'undefined'
                    ? null
                    : typeof row.informacion_adicional.no_garantizado ==
                      'undefined'
                    ? null
                    : row.informacion_adicional.no_garantizado == 'NO'
                    ? null
                    : 'background-color: #FFFFE0'
                "
              >
                <template v-if="field">
                  <template v-if="$children[_index].$options.propsData.filter">
                    {{
                      format(
                        field.split(".").reduce((a, b) => a[b], row),
                        $children[_index].$options.propsData.filter
                      )
                    }}
                  </template>
                  <template v-else>
                    {{ field.split(".").reduce((a, b) => a[b], row) }}
                  </template>
                </template>

                <template v-if="!field">
                  <div class="btn-container" v-if="actions[_index]">
                    <template v-for="(action, i) in actions[_index]">
                      <button
                        :class="action.class"
                        data-toggle="dropdown"
                        v-if="action.slot == 'icon'"
                        :key="i"
                        @click="clickEvent(row, action.attrs.slug)"
                        v-tooltip.top="action.attrs.tooltip"
                      >
                        <i :class="action.attrs.icon"></i>
                      </button>
                    </template>
                  </div>
                </template>
              </td>
            </template>
          </tr>
          <tr v-for="(field) in footerTable" :key="field.id">
            <td :colspan="fields.length - 1">Total</td>
            <td class="text-right">{{ sumColumn(field.column) | numberFormat }}</td>
          </tr>
        </template>
      </tbody>
    </table>

    <nav class="mb-2" aria-label="Navigation" v-if="pages.length > 1">
      <ul class="pagination pagination-sm justify-content-left mb-2">
        <li class="page-item">
          <a class="page-link" v-if="page != 1" @click="page--"><<</a>
        </li>
        <li class="page-item" v-bind:class="page == pageNumber?'active':''" v-for="(pageNumber, index) in pages" @click="page = pageNumber" :key="index">
          <a class="page-link">{{pageNumber}}</a>
        </li>
        <li class="page-item">
          <a class="page-link" @click="page++" v-if="page < pages.length">>></a>
        </li>
      </ul>
    </nav>

  </div>
</template>
<script>
import Vue from 'vue'
export default {
  name: "TableComponent",
  data: () => {
    return {
      _data: [],
      fields: [],
      actions: [],
      page: 1,
      pages: [],
    };
  },
  props: {
    data: {
      default: () => [],
      type: [Array, Function],
    },
    pagination: {
      default: () => false,
      type: Boolean,
    },
    perPage: {
      default: () => 25,
      type: Number,
    },
    dataLength: {
      default: () => 0,
      type: Number,
    },
    footerTable: {
      default: () => [],
      type: Array,
      required: false,
    },
    componentName: {
      default: () => "Otro",
      type: String,
      required: false,
    },
  },
  computed: {
    loading() {
      return this.$store.getters.loading;
    },
    displayedPosts() {
      return this.paginate(this.data);
    },
  },
  methods: {
    clickEvent(row, slug) {
      this.$emit("click-event", row, slug);
    },
    format(value, filter) {
      return Vue.filter(filter)(value);
    },
    sumColumn(column) {
      return this.data.reduce((prev, next) => {
        return prev + next[column];
      }, 0);
    },
    setPages() {
      let numberOfPages = Math.ceil(this.data.length / this.perPage);
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    paginate(data) {
      let page = this.page;
      let perPage = this.perPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      return data.slice(from, to);
    },
  },
  watch: {
    data() {
      this.pages = [];
      this.setPages();
    },
  },
  mounted() {
    this.setPages();

    this.$slots.label.forEach((e, i) => {
      this.fields.push(e.data.attrs.value);
      if (
        e.componentOptions.children &&
        e.componentOptions.children.length > 0
      ) {
        this.actions[i] = [];
        e.componentOptions.children.forEach(_e => {
          this.actions[i].push(_e.data);
        });
      }
    });
  }
};
</script>
<style>
.mb-2 {
  overflow: auto !important;
  width: 100%;
}
</style>
